import React from 'react';
import { ModuleBridge, TopActionBar, ReportDateRangePicker } from '../components';

export const AuditLog = () => {
    return (
        <>
            <TopActionBar>
                <ReportDateRangePicker buttonText="Update Audit Log" />
            </TopActionBar>
            <div id="backbone_audit_log_wrapper"></div>
            <ModuleBridge moduleId="audit_log_module" />
        </>
    );
};
